import React from 'react';
import { Grid, Typography } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { WhiteCard } from 'components/styles_components/card';
import { DividerContainer } from 'components/styles_components/container';
import BillingQuery from 'queries/space/billing';
import Loader from 'components/loader';
import PlanShow from 'components/space/plan/show';
import Usage from 'components/space/plan/usage';
import BillingDetailsShow from 'components/space/billing_details/show';
import PlanExpiration from 'components/space/plan/expiration';

const Show = () => {
  const setError = useError();
  const {
    data = { space: { activePlan: { placesLimit: 1 } }, plans: { plans: [] } },
    loading,
    refetch,
  } = useQuery(BillingQuery, {
    onError: () => {
      setError('error.billing.show');
    },
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <WhiteCard>
      <Typography variant="h6">
        <FormattedMessage id="plan.current" /> {data.space.activePlan.name}
      </Typography>
      <PlanExpiration endDate={data.space.activePlanEndDate} />
      <DividerContainer />
      <Grid container spacing={6} alignItems="stretch">
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" gutterBottom>
            <FormattedMessage id="plan.current.usage" />
          </Typography>
          <Usage
            label={<FormattedMessage id="plan.used.places" />}
            value={data.space.placesTotal}
            valueBuffer={data.space.activePlan.placesLimit} />
          <Usage
            label={<FormattedMessage id="plan.used.inspection_subjects" />}
            value={data.space.inspectionSubjectsTotal}
            valueBuffer={data.space.activePlan.inspectionSubjectsLimit} />
          <Usage
            label={<FormattedMessage id="plan.used.inspections" />}
            value={data.space.pendingInspectionsTotal}
            valueBuffer={data.space.activePlan.inspectionsLimit} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <BillingDetailsShow billingDetails={data.space.billingDetails} refetch={refetch} />
        </Grid>
      </Grid>
      <DividerContainer />
      <Typography variant="h5">
        <FormattedMessage id="plan.change" />
      </Typography>
      <DividerContainer />
      <Grid container spacing={2} alignItems="stretch">
        {data.plans.plans.map((plan) => (
          <PlanShow
            plan={plan}
            key={plan.id}
            refetch={refetch}
            active={data.space.activePlan.id === plan.id}
            buttonDisabled={!data.space.billingDetails} />
        ))}
      </Grid>
    </WhiteCard>
  );
};

export default Show;
